import styled from "styled-components";
import { Link } from "gatsby";
import classNames from "classnames";

const Span = styled.span`
  a {
    border: 0;
    border-radius: 50px;
    background: ${(props) =>
      props.colour === "secondary"
        ? props.theme.colours.secondary
        : props.colour === "tertiary"
        ? props.theme.colours.tertiary
        : props.colour === "white"
        ? props.theme.colours.white
        : props.colour === "green"
        ? props.theme.colours.green
        : props.theme.colours.primary};
    color: ${(props) =>
      props.colour === "white"
        ? props.theme.colours.primary
        : props.colour === "tertiary"
        ? props.theme.colours.darkGrey
        : props.theme.colours.white};
    cursor: pointer;
    font-family: ${(props) => props.theme.typography.body.font};
    font-weight: 700;
    font-size: ${(props) => (props.size === "small" ? "0.8rem" : "1.2rem")};
    padding: ${(props) => (props.size === "small" ? "5px 10px" : "10px 20px")};
    margin-bottom: ${(props) =>
      props.addBottomMargin === "small"
        ? "1rem"
        : props.addBottomMargin === "large"
        ? "2rem"
        : "0px"};
    margin-right: ${(props) =>
      props.addRightMargin === "small"
        ? "1rem"
        : props.addRightMargin === "large"
        ? "2rem"
        : "0px"};
    margin-left: ${(props) =>
      props.addLeftMargin === "small"
        ? "1rem"
        : props.addLeftMargin === "large"
        ? "2rem"
        : "0px"};
    text-align: center;
    transition: all 250ms ease;
    display: inline-block;

    &:hover {
      background: ${(props) =>
        props.colour === "secondary"
          ? props.theme.colours.secondaryHover
          : props.colour === "tertiary"
          ? props.theme.colours.tertiaryHover
          : props.colour === "white"
          ? props.theme.colours.lightGrey
          : props.colour === "green"
          ? props.theme.colours.greenHover
          : props.theme.colours.primaryHover};
      color: ${(props) =>
        props.colour === "white"
          ? props.theme.colours.primaryHover
          : props.colour === "tertiary"
          ? props.theme.colours.darkGrey
          : props.theme.colours.white};
    }
  }
`;

export const LinkButton = (props) => {
  const classes = classNames(props.className);
  return (
    <Span
      className={classes}
      colour={props.colour}
      size={props.size}
      style={props.style}
      addBottomMargin={props.addBottomMargin}
      addLeftMargin={props.addLeftMargin}
      addRightMargin={props.addRightMargin}
    >
      {!props.targetBlank && (
        <Link to={props.to} onClick={props.onClick} title={props.title}>
          {props.children}
        </Link>
      )}
      {props.targetBlank && (
        <a
          href={props.to}
          rel="noopener noreferrer"
          target="_blank"
          title={props.title}
        >
          {props.children}
        </a>
      )}
    </Span>
  );
};
